import React, { useMemo, useState } from "react";
import "./PaymentFilter.scss";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MenuItem, Select } from "@mui/material";
import ListFilterButton from "../buttons/ListFilterButton";

interface Props {
  defaultYear?: number;
  defaultMonth?: number;
  onChange?(params: { year: number; month: number | null } | null): void;
  rightAction?: React.ReactNode;
  showFiltersBtn?: boolean;
  reset_btn_link?: string;
  onClickRefresh?: () => void;
}


const PaymentFilter: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  const [year, setYear] = useState<number | null>(currentYear);
  const [month, setMonth] = useState<number | null>(currentMonth);
  const [date, setDate] = useState<Dayjs | null>(null);

  const years = useMemo(
    () =>
      Array.from({ length: currentYear - 1900 + 1 }, (_, i) => currentYear - i),
    [currentYear]
  );

  return (
    <div className="payment-filter-bar">
      <div className="home-filter-group">

      </div>

      <div className="action-group">

         <ListFilterButton />
      </div>
    </div>
  );
};

export default PaymentFilter;
